module.exports = "https://s.pinimg.com/webapp/style/images/fix_email-f5fbe7f8.png";